'use strict';

var i18nBase = require('@flex-packages/i18n-base');
var getLocaleData = require('../utils/getLocaleData.cjs');
var isTimeDurationNegative = require('../utils/timeDuration/isTimeDurationNegative.cjs');

const DEFAULT_OPTIONS = {
  omitZeros: false
};
const formatTimeDuration = (timeDuration, options) => {
  const {
    locale,
    omitZeros,
    formatDistance: formatDistanceFromOption
  } = { ...DEFAULT_OPTIONS, ...options };
  const formatDistance = formatDistanceFromOption ?? getLocaleData(locale).formatDistance;
  const result = [];
  const isNegativeDuration = isTimeDurationNegative(timeDuration);
  if (timeDuration.days !== void 0 && !(omitZeros && timeDuration.days === 0)) {
    result.push(
      formatDistance(
        "xDays",
        isNegativeDuration ? Math.abs(timeDuration.days) : timeDuration.days
      )
    );
  }
  if (timeDuration.hours !== void 0 && !(omitZeros && timeDuration.hours === 0)) {
    result.push(
      formatDistance(
        "xHours",
        isNegativeDuration ? Math.abs(timeDuration.hours) : timeDuration.hours
      )
    );
  }
  if (timeDuration.minutes !== void 0 && !(omitZeros && timeDuration.minutes === 0)) {
    result.push(
      formatDistance(
        "xMinutes",
        isNegativeDuration ? Math.abs(timeDuration.minutes) : timeDuration.minutes
      )
    );
  }
  if (timeDuration.seconds !== void 0 && !(omitZeros && timeDuration.seconds === 0)) {
    result.push(
      formatDistance(
        "xSeconds",
        isNegativeDuration ? Math.abs(timeDuration.seconds) : timeDuration.seconds
      )
    );
  }
  if (timeDuration.milliseconds !== void 0 && !(omitZeros && timeDuration.milliseconds === 0)) {
    result.push(
      String(
        isNegativeDuration ? Math.abs(timeDuration.milliseconds) : timeDuration.milliseconds
      )
    );
  }
  const resultText = result.join(" ");
  return i18nBase.localized(isNegativeDuration ? `-${resultText}` : resultText);
};

module.exports = formatTimeDuration;
//# sourceMappingURL=formatTimeDuration.cjs.map
